// STYLE FOR PLAYGROUND
export const inputPgContainerClass =
  "grid grid-cols-4 gap-2 mb-1.5 font-lato text-ys-ebony-500";
export const pgLabelClass =
  "col-start-1 col-end-2 flex items-center text-sm font-semibold";
export const pgInputClass =
  "col-start-2 col-end-5 border border-ys-ebony-200 focus:outline-none focus:border-primary-500 rounded-sm text-sm px-2 py-0.5";

// STYLE FOR SECTION IN PAGES
export const sectionWrapperStyle =
  "flex flex-col mb-8 px-[15%] md:px-[10%] text-justify sm:px-7";
export const dividerSection =
  "pb-8 border border-t-0 border-x-0 border-ys-pewter-500";
export const pageStyle =
  "min-h-[calc(100vh-72px)] font-jakarta text-ys-ebony-500";

export const sectionTitleStyle = `text-4xl font-semibold mb-2 text-primary-500 text-left`;

// STYLE FOR CONTENT (FORMAT, GRAMMAR LIST& PARENT)
export const parentListStyle = `grid grid-cols-2 gap-8 md:gap-6 sm:gap-4 mt-3 text-sm font-mono`;
export const toDoStyle = `col-start-1 col-end-2 sm:col-end-3 pt-2 px-4 border-2 border-x-0 border-b-0 bg-success-50 bg-opacity-90 border-t-success-500 pb-4`;
export const avoidStyle = `col-start-2 col-end-3 sm:col-start-1 pt-2 px-4 border-2 border-x-0 border-b-0 bg-error-50 bg-opacity-90 border-t-error-500 pb-4`;
export const iconCheckStyle = `text-success-500 scale-150 mt-1.5 mb-2`;
export const iconXStyle = `text-error-500 scale-150 mt-1.5 mb-2`;
